import React from 'react';
import './About.css';
import me from '../../../assets/aboutme.jpeg';

export const About = () => {
  return (
    <div className='container-about' id='about'>
      <div className='about-text-content'>
        <div className='about-title'>
          <h3>Sobre mí</h3>
        </div>
        <div className='about-text'>
          <hr />
          <p>
            Soy desarrollador Full Stack especializado en aplicaciones web y sistemas orientados a procesos de negocio.
            <br />
            Trabajo principalmente con React, Node.js y JavaScript, desarrollando soluciones completas que integran frontend, backend y servicios en la nube. Tengo experiencia construyendo aplicaciones en producción utilizadas por equipos de trabajo reales.
            <br />
            Me interesa seguir creciendo en el desarrollo de aplicaciones, explorando también tecnologías como React Native y Electron para soluciones móviles y de escritorio.
          </p>
        </div>
      </div>
      <div className='about-content-img'>
        <img src={me} alt='Foto de perfil de Agustin Rosano' />
      </div>
    </div>
  );
};
